import styles from './AccountingPage.module.scss';

import { TabsNavigationPage } from '@common/TabsNavigationPage';
import { useHeaderMenu } from './hooks/useHeaderMenu';
import { accountingPages } from './routes';
import { useLoadData } from './hooks/useLoadData';
import { useTabsCurrentPage } from '@hooks/useTabsCurrentPage';

export function AccountingPage() {
    useHeaderMenu();
    useLoadData();
    const onPageSelect = useTabsCurrentPage(accountingPages);

    return (
        <div className={styles.root}>
            <TabsNavigationPage
                pages={accountingPages}
                onTabSelect={onPageSelect}
            />
        </div>
    );
}
